import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c8gh4g2kci: FaireBrandEntity = {
  token: "b_c8gh4g2kci",
  type: "brand",
  name: "FINE & RAW",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3f67cd876a4331e04031271407d412571dd3e99ea0b196f37d52fec8bd9d7eef/1565290934.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/533f15f3fcac80a78644612fda80d637e1d25f8a2308840b505ba7da23afd8ad.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3f67cd876a4331e04031271407d412571dd3e99ea0b196f37d52fec8bd9d7eef/1565290934.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/533f15f3fcac80a78644612fda80d637e1d25f8a2308840b505ba7da23afd8ad.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 85,
  rating: 4.9,
  reviewCount: 266,
  isTopShop: true,
  isInsider: true,
  description:
    "FINE & RAW founder Daniel Sklaar started making small-batch chocolate in a notorious Williamsburg,\nBrooklyn artist loft in 2007. At first he shared with friends, and then friends of friends, but soon he was biking orders around to local shops as more and more people discovered the next-level flavors of his artisanal raw chocolate.\nIn 2012, the company moved to a skylit factory-café in Bushwick, where local artists and an increasing number of Brooklyn tourists stop by for a hot chocolate and a heady sniff of the chocolate-infused air. A true bean-to-bar facility, FINE & RAW starts with organic beans from sustainability-focused purveyors, and takes them all the way from their burlap sacks into finished chocolate bars, confections, and truffles.\nCrafted for chocolate lovers, FINE & RAW products are produced without dairy and using unrefined coconut sugar to extract caramel notes and deeper, more vital flavors.\nFrom the local artists and photographers who have worked with FINE & RAW on their packaging, website, and events, to the farmers all over the globe who produce the world’s best cacao, nourishing trees and soil - FINE & RAW is above all a community of people dedicated to the idea that chocolate is magic.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:04.234Z",
    importedBy: "entity-db-cli",
  },
};
